import React from "react";
import { 
	FormParagraph, 
	CustomFormRow, 
	RequiredSymbol, 
	DocketNumberFields, 
	SelectOptions, 
	getPartySection,
	getAttachmentsSection, 
	RecordationRadioButton, 
	FieldWithLabel, 
	HacRadioButton, 
	TextAreaWithLabel,
	RegionRadioButton,
	RCPAInfo,
	EnvCommentInfo,
	getTextField,
	getDropdownField,
	getTextArea,
	HaveDocketsRadioButton,
	RecordationWaterRailRadioButton
} from "./common";
import { 
	EFILING_TITLE, 
	EFILING_DESCRIPTION, 
	INFORMAL_FILING_TITLE, 
	INFORMAL_FILING_DESCRIPTION, 
	ADD_DOCKET_NUMBER_LABEL,
	REGION_HINT_ID,
	PAY_GOV_HELP_TEXT
} from "../../../resources/constants/ui";
import { 
	FILING_FEE_LABEL, 
	FEE_OPTION_FIELD, 
	CONFIRMATION_NUM_LABEL, 
	CONFIRMATION_NUM_FIELD, 
	FILING_TYPE_LABEL, 
	GENERAL_FILING_TYPE_FIELD, 
	PRIMARY_OR_SECONDARY_LABEL,
	PRIMARY_RECORDATION_NUM_FIELD, 
	PRIMARY_RECORDATION_NUM_LABEL, 
	SUBMITTER_FIELD, 
	SUBMITTER_LABEL, 
	REC_COMPANY_FIELD, 
	REC_COMPANY_LABEL, 
	ADDRESS_ONE_FIELD, 
	ADDRESS_ONE_LABEL, 
	ADDRESS_TWO_LABEL, 
	ADDRESS_TWO_FIELD, 
	CITY_FIELD, 
	CITY_LABEL, 
	STATE_LABEL, 
	STATE_FIELD, 
	ZIP_FIELD, 
	ZIP_LABEL, 
	COUNTRY_FIELD, 
	COUNTRY_LABEL, 
	PHONE_FIELD, 
	PHONE_LABEL, 
	EMAIL_FIELD, 
	EMAILS_LABEL, 
	RECORDATION_DATE_OF_AGREEMENT_FIELD, 
	RECORDATION_DATE_OF_AGREEMENT_LABEL,
	DOCUMENT_TYPE_LABEL, 
	HAC_LABEL, 
	EQUIPMENT_DESCRIPTION_FIELD, 
	EQUIPMENT_DESCRIPTION_LABEL, 
	RECORDATION_OPTION_FIELD, 
	DOCKET_NUMBERS_FIELD, 
	RECORDATION_TYPE_OF_AGREEMENT_FIELD, 
	COMPANY_FIELD,
	COMPANY_LABEL_2,
	JOB_TITLE_FIELD,
	JOB_TITLE_LABEL,
	FAX_FIELD,
	FAX_LABEL,
	ISSUE_FIELD,
	ISSUE_LABEL,
	COMMODITY_GROUP_FIELD,
	COMMODITY_GROUP_LABEL,
	REGION_LABEL,
	RAILROADS_INVOLVED_FIELD,
	RAILROADS_INVOLVED_LABEL,
	PROBLEM_LOCATION_FIELD,
	PROBLEM_LOCATION_LABEL,
	PROBLEM_DATES_FIELD,
	PROBLEM_DATES_LABEL,
	INDUSTRY_LOCATION_FIELD,
	INDUSTRY_LOCATION_LABEL,
	ISSUE_SUMMARY_LABEL,
	ISSUE_SUMMARY_FIELD,
	CONTACT_PERMISSION_FIELD,
	CONTACT_PERMISSION_LABEL,
	REGION_FIELD,
	ENVCOM_PROJECT_FIELD,
	ENVCOM_PROJECT_LABEL,
	ENVCOM_ATTENTION_FIELD,
	ENVCOM_ATTENTION_LABEL,
	ENVCOM_YOUR_NAME_FIELD,
	ENVCOM_YOUR_NAME_LABEL,
	ENVCOM_ORGANIZATION_FIELD,
	ENVCOM_ORGANIZATION_LABEL,
	ENVCOM_AFFILIATION_FIELD,
	ENVCOM_AFFILIATION_LABEL,
	ENVCOM_COMMENTS_FIELD,
	ENVCOM_COMMENTS_LABEL,
	ENVCOM_HAVE_DOCKETS_LABEL,
	ENVCOM_HAVE_DOCKETS_FIELD,
	RECORDATION_WATER_RAIL_LABEL,
	RECORDATION_WATER_RAIL_FIELD
} from "../../../resources/constants/fields";
import { 
	FILING_FEE_URL, 
	FILING_FEE_TITLE, 
	FILING_FEE_LINK, 
	PAY_GOV_URL, 
	PAY_GOV_TITLE, 
	PAY_GOV_LINK 
} from "../../../resources/constants/paths";
import { Form, Row, Col, Button } from "react-bootstrap";
import { 
	FEE_OPTIONS, 
	GENERAL_FILING_TYPES, 
	COUNTRIES, 
	US_STATE_OPTIONS, 
	ISSUES, 
	COMMODITY_GROUPS, 
	REGIONS, 
	CONTACT_OPTIONS, 
	ATTENTION_LIST,
	AFFILIATION_LIST
} from "../../../resources/constants/dropdowns";
import { getFieldError } from "../util/validation";
import { RemoveIcon } from "../../../resources/media/RemoveIcon";
import WestRegion from "../../../resources/media/west-region-states-sm.png";
import EastRegion from "../../../resources/media/east-region-states-sm.png";
import CentralRegion from "../../../resources/media/central-region-states-sm.png";
import SouthRegion from "../../../resources/media/south-region-states-sm.png";
import AlaskaHawaii from "../../../resources/media/ak-hi-sm.png";
import { DATE_PLACEHOLDER, ENV_COM_FIELD_LENGTHS, MAX_DOCKET_NUMBERS } from "../../../resources/constants/validations";
import { MAX_DOCKET_NUMBERS_ERROR } from "../../../resources/constants/errors";
import { PlusIcon } from "../../../resources/media/PlusIcon";

const getDocketNumberFields = (state, dispatch, maxDocketNumbers, optional) => {
	var hasMultiple = maxDocketNumbers > 1 || optional;
	var isBelowMax = state.data.docketNumbers.length < maxDocketNumbers;
	return (
		<>
			<DocketNumberFields
				index={0}
				handleBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
				handleChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
				dispatch={dispatch}
				errors={state.form.errors}
				docketNumbers={state.data[DOCKET_NUMBERS_FIELD]}
				optional={optional}
			/>
			{
				hasMultiple ? (
					<CustomFormRow>
						<div className={"center"}>
							{
								isBelowMax ? (
									<Button
										className="add-docket__btn"
										variant="link"
										onClick={() => {
											dispatch({type: "addDocketNumber"});
										}}
									>
										<PlusIcon/><strong className="add-title">{" "}{ADD_DOCKET_NUMBER_LABEL}</strong>
									</Button> 
								) : 
								(<>{MAX_DOCKET_NUMBERS_ERROR}</>)
							}
						</div>
					</CustomFormRow>
				) : 
				null
			}
		</>
	);
}

const getFilingHeading = (title, description) => {
	return (
		<FormParagraph>
			<h3>
				<strong>{title}</strong>
			</h3>
			<p>{description}</p>
		</FormParagraph>
	)
}

export const FormalFilingFields = (state, dispatch) => {
	return (
		<React.Fragment>
			<FormParagraph>
				<p className="formal-filing-paragraph">{EFILING_DESCRIPTION}</p>
			</FormParagraph>
			{getFilingHeading(EFILING_TITLE)}
		
			{getDocketNumberFields(state, dispatch, MAX_DOCKET_NUMBERS)}

			<CustomFormRow
				labelText={
					<span><RequiredSymbol/>{FILING_FEE_LABEL}{" "}
						<a
							href={FILING_FEE_URL}
							title={FILING_FEE_TITLE}
							target="_blank"
							rel="noopener noreferrer"
						>
							{FILING_FEE_LINK}
						</a>
						{":"}
					</span>
				}
			>
				<Form.Control
					required
					as="select"
					id={FEE_OPTION_FIELD}
					name={FEE_OPTION_FIELD}
					value={state.data[FEE_OPTION_FIELD]}
					onBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
					onChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
					isInvalid={
						state.form.errors.filter(
							error => error.fieldId === FEE_OPTION_FIELD
						).length > 0
					}
				>
					<SelectOptions
						options={FEE_OPTIONS.map(opt => {
							return opt.value;
						})}
					/>
				</Form.Control>
				<Form.Control.Feedback type="invalid">
					{state.form.errors
						.filter(
							error => error.fieldId === FEE_OPTION_FIELD
						)
						.reduce(
							(acc, cur) => [...acc, cur.errorMsg + "\n"],
							[]
						)}
				</Form.Control.Feedback>
			</CustomFormRow>
			{state.data.feeOption === FEE_OPTIONS[2].value ? null : ( //No fee required
				<CustomFormRow
					labelText={
						<span>
							<RequiredSymbol/><a
								href={PAY_GOV_URL}
								title={PAY_GOV_TITLE}
								target="_blank"
								rel="noopener noreferrer"
							>
								{PAY_GOV_LINK}
							</a>{" "}
							{CONFIRMATION_NUM_LABEL}
						</span>
					}
				>
					<Form.Control
						required={true}
						type="text"
						id={CONFIRMATION_NUM_FIELD}
						name={CONFIRMATION_NUM_FIELD}
						onBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
						onChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
						isInvalid={
							state.form.errors.filter(
								error =>
									error.fieldId ===
									CONFIRMATION_NUM_FIELD
							).length > 0
						}
					/>
				</CustomFormRow>
            )}
            <hr />
            {getPartySection(state, dispatch)}
            <br />
            <hr />
            <br />
            {getAttachmentsSection(state, dispatch)}
			<br/>
			<hr/>
		</React.Fragment>
	)
}

export const OtherFilingFields = (state, dispatch) => {
	return (
		<React.Fragment>

			{getFilingHeading(INFORMAL_FILING_TITLE)}

			{getDocketNumberFields(state, dispatch, MAX_DOCKET_NUMBERS)}

			<CustomFormRow labelText={<span><RequiredSymbol/>{FILING_TYPE_LABEL}</span>}>
				<Form.Control
					required
					as="select"
					id={GENERAL_FILING_TYPE_FIELD}
					name={GENERAL_FILING_TYPE_FIELD}
					value={state.data[GENERAL_FILING_TYPE_FIELD]}
					onBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
					onChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
					isInvalid={
						state.form.errors.filter(
							error =>
								error.fieldId ===
								GENERAL_FILING_TYPE_FIELD
						).length > 0
					}
				>
					<SelectOptions options={["", ...GENERAL_FILING_TYPES]} />
				</Form.Control>
			</CustomFormRow>
            <hr />
            {getPartySection(state, dispatch)}
            <br />
            <hr />
            <br />
            {getAttachmentsSection(state, dispatch)}
			<br/>
			<hr/>
		</React.Fragment>
	)
}

export const RecordationFields = (state, dispatch) => {
	return (
		<React.Fragment>
			<br/>
			<CustomFormRow
				labelText={<span><RequiredSymbol/>{RECORDATION_WATER_RAIL_LABEL}</span>}
			>
				<RecordationWaterRailRadioButton
					value={state.data[RECORDATION_WATER_RAIL_FIELD]}
					handleChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
					inline={true}
					isInvalid={
						state.form.errors.filter(
							error => error.fieldId === RECORDATION_WATER_RAIL_FIELD
						).length > 0
					}
				/>
			</CustomFormRow>
			<CustomFormRow
				labelText={<span><RequiredSymbol/>{PRIMARY_OR_SECONDARY_LABEL}</span>}
			>
				<RecordationRadioButton
					value={state.data[RECORDATION_OPTION_FIELD]}
					handleChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
					inline={true}
					isInvalid={
						state.form.errors.filter(
							error => error.fieldId === RECORDATION_OPTION_FIELD
						).length > 0
					}
				/>
			</CustomFormRow>

			<FieldWithLabel
				id={PRIMARY_RECORDATION_NUM_FIELD}
				name={PRIMARY_RECORDATION_NUM_FIELD}
				value={state.data[PRIMARY_RECORDATION_NUM_FIELD]}
				labelText={PRIMARY_RECORDATION_NUM_LABEL}
				isVisible={state.data.recordationOption === "Secondary"}
				handleBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
				handleChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
				isInvalid={
					state.form.errors.filter(
						error => error.fieldId === PRIMARY_RECORDATION_NUM_FIELD
					).length > 0
				}
				invalid={getFieldError(state.form.errors, PRIMARY_RECORDATION_NUM_FIELD)}
			/>
			<br/>
			<CustomFormRow
					labelText={
						<span>
							<RequiredSymbol/><a
								href={PAY_GOV_URL}
								title={PAY_GOV_TITLE}
								target="_blank"
								rel="noopener noreferrer"
							>
								{PAY_GOV_LINK}
							</a>{" "}
							{CONFIRMATION_NUM_LABEL}
						</span>
					}
				>
					<Form.Control
						required={true}
						type="text"
						id={CONFIRMATION_NUM_FIELD}
						name={CONFIRMATION_NUM_FIELD}
						onBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
						onChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
						isInvalid={
							state.form.errors.filter(
								error =>
									error.fieldId ===
									CONFIRMATION_NUM_FIELD
							).length > 0
						}
					/>
					<Form.Text>{PAY_GOV_HELP_TEXT}</Form.Text>
				</CustomFormRow>
			<FieldWithLabel
				id={SUBMITTER_FIELD}
				name={SUBMITTER_FIELD}
				labelText={SUBMITTER_LABEL}
				handleBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
				handleChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
				isInvalid={
					state.form.errors.filter(
						error => error.fieldId === SUBMITTER_FIELD
					).length > 0
				}
				invalid={getFieldError(state.form.errors, SUBMITTER_FIELD)}
			/>
			<FieldWithLabel
				id={REC_COMPANY_FIELD}
				name={REC_COMPANY_FIELD}
				labelText={REC_COMPANY_LABEL}
				handleBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
				handleChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
				isInvalid={
					state.form.errors.filter(
						error => error.fieldId === REC_COMPANY_FIELD
					).length > 0
				}
				invalid={getFieldError(state.form.errors, REC_COMPANY_FIELD)}
			/>
			<FieldWithLabel
				id={ADDRESS_ONE_FIELD}
				name={ADDRESS_ONE_FIELD}
				labelText={ADDRESS_ONE_LABEL}
				handleBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
				handleChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
				isInvalid={
					state.form.errors.filter(
						error => error.fieldId === ADDRESS_ONE_FIELD
					).length > 0
				}
				invalid={getFieldError(state.form.errors, ADDRESS_ONE_FIELD)}
			/>
			<CustomFormRow labelText={ADDRESS_TWO_LABEL}>
				<Form.Control
					type="text"
					id={ADDRESS_TWO_FIELD}
					name={ADDRESS_TWO_FIELD}
					onBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
					onChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
				/>
			</CustomFormRow>
			<FieldWithLabel
				id={CITY_FIELD}
				name={CITY_FIELD}
				labelText={CITY_LABEL}
				handleBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
				handleChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
				isInvalid={
					state.form.errors.filter(
						error => error.fieldId === CITY_FIELD
					).length > 0
				}
				invalid={getFieldError(state.form.errors, CITY_FIELD)}
			/>
			{ state.data.country === COUNTRIES[0] ?
				<CustomFormRow labelText={<span><RequiredSymbol />{STATE_LABEL}</span>}>
					<Form.Control
						required
						as="select"
						name={STATE_FIELD}
						id={STATE_FIELD}
						value={state.data[STATE_FIELD]}
						onBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
						onChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
						isInvalid={
							state.form.errors.filter(
								error =>
									error.fieldId === STATE_FIELD
							).length > 0
						}
						invalid={getFieldError(state.form.errors, STATE_FIELD)}
					>
						<option value="" style={{"display":"none"}}></option>
						{US_STATE_OPTIONS.map((state, index) => {
							return (
								<option key={`${state.name}-${index}`} value={state.abbrv}>
									{`${state.abbrv} - ${state.name}`}
								</option>
							)
						})}
					</Form.Control>
				</CustomFormRow>
				:	
				<FieldWithLabel
					id={STATE_FIELD}
					name={STATE_FIELD}
					labelText={STATE_LABEL}
					handleBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
					handleChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
					value={state.data[STATE_FIELD]}
					isInvalid={
						state.form.errors.filter(
							error => error.fieldId === STATE_FIELD
						).length > 0
					}
					invalid={getFieldError(state.form.errors, STATE_FIELD)}
				/>
			}
			<FieldWithLabel
                id={ZIP_FIELD}
				name={ZIP_FIELD}
				labelText={ZIP_LABEL}
				handleBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
				handleChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
				isInvalid={
					state.form.errors.filter(
						error => error.fieldId === ZIP_FIELD
					).length > 0
				}
				invalid={getFieldError(state.form.errors, ZIP_FIELD)}
			/>
			<CustomFormRow labelText={<span><RequiredSymbol />{COUNTRY_LABEL}</span>}>
				<Form.Control
					required
					as="select"
					name={COUNTRY_FIELD}
					id={COUNTRY_FIELD}
					value={state.data[COUNTRY_FIELD]}
					onBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
					onChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
					isInvalid={
						state.form.errors.filter(
							error =>
								error.fieldId === COUNTRY_FIELD
						).length > 0
					}
					invalid={getFieldError(state.form.errors, COUNTRY_FIELD)}
				>
					<SelectOptions options={COUNTRIES} />
				</Form.Control>
			</CustomFormRow>
			<FieldWithLabel
				id={PHONE_FIELD}
				name={PHONE_FIELD}
				labelText={PHONE_LABEL}
				handleBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
				handleChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
				isInvalid={
					state.form.errors.filter(
						error => error.fieldId === PHONE_FIELD
					).length > 0
				}
				invalid={getFieldError(state.form.errors, PHONE_FIELD)}
			/>
			<FieldWithLabel
				id={EMAIL_FIELD}
				name={EMAIL_FIELD}
				labelText={EMAILS_LABEL}
				handleBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
				handleChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
				isInvalid={
					state.form.errors.filter(
						error => error.fieldId === EMAIL_FIELD
					).length > 0
				}
				invalid={getFieldError(state.form.errors, EMAIL_FIELD)}
			/>
			<CustomFormRow labelText={<span><RequiredSymbol/>{RECORDATION_DATE_OF_AGREEMENT_LABEL}</span>}>
				<Row className="date-row">
					<Col>
						<Form.Control
							type="date"
							id={RECORDATION_DATE_OF_AGREEMENT_FIELD}
							name={RECORDATION_DATE_OF_AGREEMENT_FIELD}
							defaultValue={state.data[RECORDATION_DATE_OF_AGREEMENT_FIELD]}
							onChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
							placeholder={DATE_PLACEHOLDER}
							className={`vert-center`}
							isInvalid={
								state.form.errors.filter(
									error => error.fieldId === RECORDATION_DATE_OF_AGREEMENT_FIELD
								).length > 0
							}
						/>
						{
							getFieldError(state.form.errors, RECORDATION_DATE_OF_AGREEMENT_FIELD).length ? 
							<Form.Control.Feedback type="invalid">
								{getFieldError(state.form.errors, RECORDATION_DATE_OF_AGREEMENT_FIELD)}
							</Form.Control.Feedback>
							: null
						}
					</Col>
					{typeof InstallTrigger === 'undefined' ? 
						<Button
							className="clear_date__btn"
							variant="link"
							onClick={(e) => { e.persist(); dispatch({type: "clearDate", event: e });}}
						>
							<RemoveIcon />
						</Button>
					: null}
				</Row>
			</CustomFormRow>
			<FieldWithLabel
				id={RECORDATION_TYPE_OF_AGREEMENT_FIELD}
				name={RECORDATION_TYPE_OF_AGREEMENT_FIELD}
				labelText={DOCUMENT_TYPE_LABEL}
				displayLabelAsTable={true}
				handleBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
				handleChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
				isInvalid={
					state.form.errors.filter(
						error => error.fieldId === RECORDATION_TYPE_OF_AGREEMENT_FIELD
					).length > 0
				}
				invalid={getFieldError(state.form.errors, RECORDATION_TYPE_OF_AGREEMENT_FIELD)}
			/>
			<CustomFormRow
				displayLabelAsTable={true}
				labelText={
					<span><RequiredSymbol/>
						{HAC_LABEL}
					</span>
				}
			>
				<HacRadioButton
					value={state.data.hasHac}
					handleChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
					inline={true}
				/>
			</CustomFormRow>
			<TextAreaWithLabel
				id={EQUIPMENT_DESCRIPTION_FIELD}
				name={EQUIPMENT_DESCRIPTION_FIELD}
				labelText={EQUIPMENT_DESCRIPTION_LABEL}
				handleBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
				handleChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
				numRows="5"
				isInvalid={
					state.form.errors.filter(
						error => error.fieldId === EQUIPMENT_DESCRIPTION_FIELD
					).length > 0
				}
				invalid={getFieldError(state.form.errors, EQUIPMENT_DESCRIPTION_FIELD)}
			/>
			<br/>
            {getPartySection(state, dispatch)}
			<br/>
			<hr/>
			<br/>
			{getAttachmentsSection(state, dispatch)}
			<br/>
			<hr/>
		</React.Fragment>
	)
}

export const RCPAFields = (state, dispatch) => {
	return (
		<React.Fragment>
			<RCPAInfo/>
			<br/>
			<div className="panel">
			<FormParagraph>
				<h3>
					<strong>{"Submitter Information"}</strong>
				</h3>
			</FormParagraph>
			<FieldWithLabel
				id={SUBMITTER_FIELD}
				name={SUBMITTER_FIELD}
				labelText={SUBMITTER_LABEL}
				handleBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
				handleChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
				isInvalid={
					state.form.errors.filter(
						error => error.fieldId === SUBMITTER_FIELD
					).length > 0
				}
				invalid={getFieldError(state.form.errors, SUBMITTER_FIELD)}
			/>
			<FieldWithLabel
				optional={true}
				id={COMPANY_FIELD}
				name={COMPANY_FIELD}
				labelText={COMPANY_LABEL_2}
				handleBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
				handleChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
				isInvalid={
					state.form.errors.filter(
						error => error.fieldId === COMPANY_FIELD
					).length > 0
				}
				invalid={getFieldError(state.form.errors, COMPANY_FIELD)}
			/>
			<FieldWithLabel
				optional={true}
				id={JOB_TITLE_FIELD}
				name={JOB_TITLE_FIELD}
				labelText={JOB_TITLE_LABEL}
				handleBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
				handleChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
				isInvalid={
					state.form.errors.filter(
						error => error.fieldId === JOB_TITLE_FIELD
					).length > 0
				}
				invalid={getFieldError(state.form.errors, JOB_TITLE_FIELD)}
			/>
			<FieldWithLabel
				optional={true}
				id={ADDRESS_ONE_FIELD}
				name={ADDRESS_ONE_FIELD}
				labelText={ADDRESS_ONE_LABEL}
				handleBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
				handleChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
				isInvalid={
					state.form.errors.filter(
						error => error.fieldId === ADDRESS_ONE_FIELD
					).length > 0
				}
				invalid={getFieldError(state.form.errors, ADDRESS_ONE_FIELD)}
			/>
			<CustomFormRow labelText={ADDRESS_TWO_LABEL}>
				<Form.Control
					type="text"
					id={ADDRESS_TWO_FIELD}
					name={ADDRESS_TWO_FIELD}
					onBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
					onChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
				/>
			</CustomFormRow>
			<FieldWithLabel
				optional={true}
				id={CITY_FIELD}
				name={CITY_FIELD}
				labelText={CITY_LABEL}
				handleBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
				handleChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
				isInvalid={
					state.form.errors.filter(
						error => error.fieldId === CITY_FIELD
					).length > 0
				}
				invalid={getFieldError(state.form.errors, CITY_FIELD)}
			/>
			{ state.data.country === COUNTRIES[0] ?
				<CustomFormRow labelText={<span>{STATE_LABEL}</span>}>
					<Form.Control
						as="select"
						name={STATE_FIELD}
						id={STATE_FIELD}
						value={state.data[STATE_FIELD]}
						onBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
						onChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
						isInvalid={
							state.form.errors.filter(
								error =>
									error.fieldId === STATE_FIELD
							).length > 0
						}
						invalid={getFieldError(state.form.errors, STATE_FIELD)}
					>
						<option value="" style={{"display":"none"}}></option>
						{US_STATE_OPTIONS.map((state, index) => {
							return (
								<option key={`${state.name}-${index}`} value={state.abbrv}>
									{`${state.abbrv} - ${state.name}`}
								</option>
							)
						})}
					</Form.Control>
				</CustomFormRow>
				:	
				<FieldWithLabel
					optional={true}
					id={STATE_FIELD}
					name={STATE_FIELD}
					labelText={STATE_LABEL}
					handleBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
					handleChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
					value={state.data[STATE_FIELD]}
					isInvalid={
						state.form.errors.filter(
							error => error.fieldId === STATE_FIELD
						).length > 0
					}
					invalid={getFieldError(state.form.errors, STATE_FIELD)}
				/>
			}
			<FieldWithLabel
				optional={true}
                id={ZIP_FIELD}
				name={ZIP_FIELD}
				labelText={ZIP_LABEL}
				handleBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
				handleChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
				isInvalid={
					state.form.errors.filter(
						error => error.fieldId === ZIP_FIELD
					).length > 0
				}
				invalid={getFieldError(state.form.errors, ZIP_FIELD)}
			/>
			<CustomFormRow labelText={<span>{COUNTRY_LABEL}</span>}>
				<Form.Control
					as="select"
					name={COUNTRY_FIELD}
					id={COUNTRY_FIELD}
					value={state.data[COUNTRY_FIELD]}
					onBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
					onChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
					isInvalid={
						state.form.errors.filter(
							error =>
								error.fieldId === COUNTRY_FIELD
						).length > 0
					}
					invalid={getFieldError(state.form.errors, COUNTRY_FIELD)}
				>
					<SelectOptions options={COUNTRIES} />
				</Form.Control>
			</CustomFormRow>
			<FieldWithLabel
				id={EMAIL_FIELD}
				name={EMAIL_FIELD}
				labelText={EMAILS_LABEL}
				handleBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
				handleChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
				isInvalid={
					state.form.errors.filter(
						error => error.fieldId === EMAIL_FIELD
					).length > 0
				}
				invalid={getFieldError(state.form.errors, EMAIL_FIELD)}
			/>
			<FieldWithLabel
				id={PHONE_FIELD}
				name={PHONE_FIELD}
				labelText={PHONE_LABEL}
				handleBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
				handleChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
				isInvalid={
					state.form.errors.filter(
						error => error.fieldId === PHONE_FIELD
					).length > 0
				}
				invalid={getFieldError(state.form.errors, PHONE_FIELD)}
			/>
			<FieldWithLabel
				optional={true}
				id={FAX_FIELD}
				name={FAX_FIELD}
				labelText={FAX_LABEL}
				handleBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
				handleChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
				isInvalid={
					state.form.errors.filter(
						error => error.fieldId === FAX_FIELD
					).length > 0
				}
				invalid={getFieldError(state.form.errors, FAX_FIELD)}
			/>
			</div>
			<div className="panel">
			<FormParagraph>
				<h3>
					<strong>{"Railroad Information"}</strong>
				</h3>
			</FormParagraph>
			<CustomFormRow labelText={<span><RequiredSymbol/>{ISSUE_LABEL}</span>}>
				<Form.Control
					required
					as="select"
					name={ISSUE_FIELD}
					id={ISSUE_FIELD}
					value={state.data[ISSUE_FIELD]}
					onBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
					onChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
					isInvalid={
						state.form.errors.filter(
							error =>
								error.fieldId === ISSUE_FIELD
						).length > 0
					}
					invalid={getFieldError(state.form.errors, ISSUE_FIELD)}
				>
					<SelectOptions options={["", ...ISSUES]} />
				</Form.Control>
			</CustomFormRow>
			<CustomFormRow labelText={<span><RequiredSymbol/>{COMMODITY_GROUP_LABEL}</span>}>
				<Form.Control
					required
					as="select"
					name={COMMODITY_GROUP_FIELD}
					id={COMMODITY_GROUP_FIELD}
					value={state.data[COMMODITY_GROUP_FIELD]}
					onBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
					onChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
					isInvalid={
						state.form.errors.filter(
							error =>
								error.fieldId === COMMODITY_GROUP_FIELD
						).length > 0
					}
					invalid={getFieldError(state.form.errors, COMMODITY_GROUP_FIELD)}
				>
					<SelectOptions options={["", ...COMMODITY_GROUPS]} />
				</Form.Control>
			</CustomFormRow>
			<CustomFormRow
				labelText={
					<span><RequiredSymbol/>
						{REGION_LABEL}
					</span>
				}
			>
				<RegionRadioButton
					value={state.data.region}
					handleChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
					inline={true}
					isInvalid={
						state.form.errors.filter(
							error => error.fieldId === REGION_FIELD
						).length > 0
					}
				/>
			</CustomFormRow>
			<Row>
				<Col lg={2}></Col>
				<Col lg={8}>
					<Row>
						<Col md={5}/>
						<Col md={7}>
							<div className="region-box">
								<div className="region-info" id={REGION_HINT_ID}/>
								<div className="region region-west">
									<img
										src={WestRegion}
										alt={REGIONS[3]}
										className={state.data.region === REGIONS[3].name ? "active" : null}
									/>
								</div>
								<div className="region region-east">
									<img 
										src={EastRegion}
										alt={REGIONS[0]}
										className={state.data.region === REGIONS[0].name ? "active" : null}
									/>
								</div>
								<div className="region region-central">
									<img 
										src={CentralRegion}
										alt={REGIONS[2]}
										className={state.data.region === REGIONS[2].name ? "active" : null}
									/>
								</div>
								<div className="region region-south">
									<img 
										src={SouthRegion}
										alt={REGIONS[1]}
										className={state.data.region === REGIONS[1].name ? "active" : null}
									/>
								</div>
								<div className="region region-ak-hi">
									<img 
										src={AlaskaHawaii}
										alt={REGIONS[3]}
										className={state.data.region === REGIONS[3].name ? "active" : null}
									/>
								</div>
							</div>
						</Col>
					</Row>
				</Col>
				<Col lg={2}></Col>
			</Row>
			<TextAreaWithLabel
				optional
				id={RAILROADS_INVOLVED_FIELD}
				name={RAILROADS_INVOLVED_FIELD}
				labelText={RAILROADS_INVOLVED_LABEL}
				handleBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
				handleChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
				numRows="2"
				isInvalid={
					state.form.errors.filter(
						error => error.fieldId === RAILROADS_INVOLVED_FIELD
					).length > 0
				}
				invalid={getFieldError(state.form.errors, RAILROADS_INVOLVED_FIELD)}
			/>
			<TextAreaWithLabel
				optional
				id={PROBLEM_LOCATION_FIELD}
				name={PROBLEM_LOCATION_FIELD}
				labelText={PROBLEM_LOCATION_LABEL}
				handleBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
				handleChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
				numRows="2"
				isInvalid={
					state.form.errors.filter(
						error => error.fieldId === PROBLEM_LOCATION_FIELD
					).length > 0
				}
				invalid={getFieldError(state.form.errors, PROBLEM_LOCATION_FIELD)}
			/>
			<TextAreaWithLabel
				optional
				id={INDUSTRY_LOCATION_FIELD}
				name={INDUSTRY_LOCATION_FIELD}
				labelText={INDUSTRY_LOCATION_LABEL}
				handleBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
				handleChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
				numRows="2"
				isInvalid={
					state.form.errors.filter(
						error => error.fieldId === INDUSTRY_LOCATION_FIELD
					).length > 0
				}
				invalid={getFieldError(state.form.errors, INDUSTRY_LOCATION_FIELD)}
			/>
			<TextAreaWithLabel
				optional
				id={PROBLEM_DATES_FIELD}
				name={PROBLEM_DATES_FIELD}
				labelText={PROBLEM_DATES_LABEL}
				handleBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
				handleChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
				numRows="2"
				isInvalid={
					state.form.errors.filter(
						error => error.fieldId === PROBLEM_DATES_FIELD
					).length > 0
				}
				invalid={getFieldError(state.form.errors, PROBLEM_DATES_FIELD)}
			/>
			<TextAreaWithLabel
				id={ISSUE_SUMMARY_FIELD}
				name={ISSUE_SUMMARY_FIELD}
				labelText={ISSUE_SUMMARY_LABEL}
				handleBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
				handleChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
				numRows="5"
				isInvalid={
					state.form.errors.filter(
						error => error.fieldId === ISSUE_SUMMARY_FIELD
					).length > 0
				}
				invalid={getFieldError(state.form.errors, ISSUE_SUMMARY_FIELD)}
			/>
			<CustomFormRow labelText={<span><RequiredSymbol/>{CONTACT_PERMISSION_LABEL}</span>}>
				<Form.Control
					required
					as="select"
					name={CONTACT_PERMISSION_FIELD}
					id={CONTACT_PERMISSION_FIELD}
					value={state.data[CONTACT_PERMISSION_FIELD]}
					onBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
					onChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
					isInvalid={
						state.form.errors.filter(
							error =>
								error.fieldId === CONTACT_PERMISSION_FIELD
						).length > 0
					}
					invalid={getFieldError(state.form.errors, CONTACT_PERMISSION_FIELD)}
				>
					<SelectOptions options={["", ...CONTACT_OPTIONS]} />
				</Form.Control>
			</CustomFormRow>
			</div>
			<div className="panel">
			<FormParagraph>
				<h3>
					<strong>{"Attachment(s)"}</strong>
				</h3>
			</FormParagraph>
				{getAttachmentsSection(state, dispatch)}
			</div>
		</React.Fragment>
	)
}

export const EnvironmentalCommentFields = (state, dispatch) => {
	return (
		<React.Fragment>
			<div className="panel">
				<CustomFormRow
					labelSize={4}
					labelText={<span><RequiredSymbol/>{ENVCOM_HAVE_DOCKETS_LABEL}</span>}
				>
					<HaveDocketsRadioButton
						value={state.data[ENVCOM_HAVE_DOCKETS_FIELD]}
						handleChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
						inline={true}
						isInvalid={
							state.form.errors.filter(
								error => error.fieldId === ENVCOM_HAVE_DOCKETS_FIELD
							).length > 0
						}
					/>
				</CustomFormRow>
				{
					state.data[ENVCOM_HAVE_DOCKETS_FIELD] && state.data[ENVCOM_HAVE_DOCKETS_FIELD] === "true" ?
					<>
						{getDocketNumberFields(state, dispatch, 5)}
					</> :
					null
				}
				{getTextField(state, dispatch, ENVCOM_PROJECT_FIELD, ENVCOM_PROJECT_LABEL)}
				{getDropdownField(state, dispatch, ENVCOM_ATTENTION_FIELD, ENVCOM_ATTENTION_LABEL, ATTENTION_LIST, state.data[ENVCOM_ATTENTION_FIELD])}
				{getTextField(state, dispatch, ENVCOM_YOUR_NAME_FIELD, ENVCOM_YOUR_NAME_LABEL)}
				{getTextField(state, dispatch, ENVCOM_ORGANIZATION_FIELD, ENVCOM_ORGANIZATION_LABEL, true)}
				{getDropdownField(state, dispatch, ENVCOM_AFFILIATION_FIELD, ENVCOM_AFFILIATION_LABEL, AFFILIATION_LIST, state.data[ENVCOM_AFFILIATION_FIELD])}
				{getTextField(state, dispatch, ADDRESS_ONE_FIELD, ADDRESS_ONE_LABEL)}
				{getTextField(state, dispatch, ADDRESS_TWO_FIELD, ADDRESS_TWO_LABEL, true)}
				{getTextField(state, dispatch, CITY_FIELD, CITY_LABEL)}
				{ state.data.country === COUNTRIES[0] ?
					getDropdownField(state, dispatch, STATE_FIELD, STATE_LABEL, ["", ...US_STATE_OPTIONS], state.data[STATE_FIELD])
					: getTextField(state, dispatch, STATE_FIELD, STATE_LABEL)
				}
				{getTextField(state, dispatch, ZIP_FIELD, ZIP_LABEL)}
				{getDropdownField(state, dispatch, COUNTRY_FIELD, COUNTRY_LABEL, COUNTRIES, state.data[COUNTRY_FIELD])}
				{getTextField(state, dispatch, PHONE_FIELD, PHONE_LABEL, true)}
				{getTextField(state, dispatch, EMAIL_FIELD, EMAILS_LABEL)}
				{getTextArea(state, dispatch, ENVCOM_COMMENTS_FIELD, ENVCOM_COMMENTS_LABEL, "5", true, ENV_COM_FIELD_LENGTHS[ENVCOM_COMMENTS_FIELD])}
			</div>
			<div className="panel">
				{getAttachmentsSection(state, dispatch)}
			</div>
			<br/>
		</React.Fragment>
	)
}